import { ref, reactive, Ref } from 'vue'
import Index from './main.vue'

export default Index

type paramsType = {
  teamColor: Ref<string>
  teamName: Ref<string>
  descName: Ref<string>
  descColor: Ref<string>
  isEase: Ref<boolean>
  onUpdate: (key: string, ...args: unknown[]) => Promise<unknown> | unknown
  allowEditName: Ref<boolean>
  allowEditDesc: Ref<boolean>
}

export const useTeamInfo = (
  groupId: Ref<number>,
  {
    teamColor,
    teamName,
    descName,
    descColor,
    isEase,
    onUpdate,
    allowEditName,
    allowEditDesc
  }: paramsType
) => {
  const props = ref({
    groupId,
    teamColor,
    teamName,
    descName,
    descColor,
    isEase,
    allowEditName,
    allowEditDesc,
    onUpdate
  })
  return reactive({
    props
  })
}
